// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".filter-disease-selector[data-v-35179c9a] .el-select {\n  width: 0.78125rem !important;\n}", "",{"version":3,"sources":["D:/source/200xth/xth2.web/<input css 76>"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B","file":"prescriptionList.vue","sourcesContent":[".filter-disease-selector /deep/.el-select {\n  width: 0.78125rem !important;\n}"]}]);
// Exports
module.exports = exports;
